// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ContactIdMappingListPagingResultModel from '../../model/contact-id-mapping-list-paging-result-model';
import ContactIdMappingListPagingResultDTO from '../dto/contact-id-mapping-list-paging-result-dto';
import dtoSchema from '../schemas/contact-id-mapping-list-paging-result-schema';
import ContactIdMappingListModel from '../../model/contact-id-mapping-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ContactIdMappingListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ContactIdMappingListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ContactIdMappingListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ContactIdMappingListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ContactIdMappingListPagingResultDTO>): ContactIdMappingListPagingResultModel;
  static toModel(dto: DeepPartial<ContactIdMappingListPagingResultDTO> | undefined | null): ContactIdMappingListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<ContactIdMappingListPagingResultDTO> | undefined | null): ContactIdMappingListPagingResultModel | undefined {
    return dto ? new ContactIdMappingListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ContactIdMappingListPagingResultModel> | ContactIdMappingListPagingResultModel): ContactIdMappingListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ContactIdMappingListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ContactIdMappingListPagingResultModel, can not map to ContactIdMappingListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
